import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { isSponsoredAccountAndDimension } from '../../../../../config/report-predicates/isSponsoredAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { SALES_GROUP } from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import { defaultColumns, customColumns } from './reportPresets';
import { SALES_GROUP_REPORT_ID } from './salesGroupReportId';

export const salesGroupReportConfig = {
    id: SALES_GROUP_REPORT_ID,
    label: 'Sales Group',
    permissions: [REPORT_PERMISSION.REP_BREAKDOWN_VIEW],
    visibilityCondition: isSponsoredAccountAndDimension,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-sales-group',
    rowIdField: SALES_GROUP.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    filters: [
        {
            id: FILTER_TYPE.SALES_PERSON,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
    ],
};

export default salesGroupReportConfig;
